import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.scss'],
    standalone: false
})
export class DownloadComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
